import { type IdentityProviderProps } from '@vp/ubik-context';

type VPAuthConfig = IdentityProviderProps['auth'];

export const createAuthConfig = (culture: string): VPAuthConfig => ({
  culture,
  options: {
    requireSession: true,
  },
});
